import { Link, WithRecord } from "react-admin";
import { ENV } from "../../ra-lb-tools/utils/tools";
import { Launch } from "@mui/icons-material";

export const KeycloakLink = ({ entity, id = "externalId", ...props }) => {
  const keycloakUri =
    ENV().KEYCLOAK_CONFIG.url + "/admin/master/console/#/harbor/";

  return (
    <WithRecord
      render={(record) => {
        const k_id = record[id];
        if (!k_id) return null;

        return (
          <Link
            target="_blank"
            to={`${keycloakUri}${entity}/${k_id}/settings`}
            title={`Check ${entity} on Keycloak`}
            {...props}
          >
            <Launch />
          </Link>
        );
      }}
    />
  );
};
